import { Button } from '@mui/material'
import Image from 'next/image'
import Link from 'next/link'
import { CaseStudy } from 'src/utils/case-studies'

const Card = ({
  study,
  variant = 'normal'
}: {
  study: CaseStudy
  variant?: 'normal' | 'footer'
}) => {
  return (
    <Link href={`/case-study/${study.slug}`} key={study.id}>
      <div className="rounded-[12px] h-full bg-white">
        <div
          className="h-full p-4 rounded-[12px] shadow-[0px_4px_12px_0px_rgba(0,0,0,0.1)] cursor-pointer transition-shadow duration-400 flex flex-col justify-between gap-2 hover:shadow-2xl"
          style={{
            background: variant === 'footer' ? `${study.color}60` : 'white'
          }}>
          <div>
            <Image
              src={study.testimonial.chain.image}
              alt={study.testimonial.chain.name}
              className="w-[60px] h-[60px] object-contain"
              width={60}
              height={60}
            />

            <p
              className={`mt-3 font-semibold text-black ${
                variant === 'footer' ? 'text-[14px]' : 'text-[18px]'
              }`}>
              {study.title}
            </p>

            {variant !== 'footer' && (
              <div
                className="mt-2 sm:col-span-8 flex flex-col justify-between gap-4 sm:gap-8 rounded-[12px] p-2 md:p-4 lg:p-6 relative"
                style={{
                  background: `linear-gradient(to bottom right, #FDD29430, #FDD294)`
                }}>
                <p
                  className={`text-[12px] lg:text-[14px] font-semibold`}
                  style={{ color: '#593301' }}>
                  "{study.testimonial.text.slice(0, 120)}..."
                </p>
                <div className="flex items-center gap-2">
                  <Image
                    src={study.testimonial.author.image}
                    alt={study.testimonial.chain.name}
                    width={40}
                    height={40}
                    className="h-[40px] w-[40px] rounded-full object-cover"
                  />
                  <div>
                    <p
                      className={`text-[13px] lg:text-[15px] font-semibold`}
                      style={{ color: '#593301' }}>
                      {study.testimonial.author.name}
                    </p>
                    <p
                      className={`text-[11px] lg:text-[13px] font-normal`}
                      style={{ color: '#593301' }}>
                      {study.testimonial.author.designation}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>

          {variant !== 'footer' && (
            <Button
              sx={{
                bgcolor: '#F3F1F1 !important',
                color: '#000',
                py: 2,
                fontFamily: 'Sora',
                fontSize: '16px',
                fontWeight: 600,
                textTransform: 'none',
                '&:hover': {
                  bgcolor: '#E6E6E6 !important'
                }
              }}>
              Read Case Study
            </Button>
          )}
        </div>
      </div>
    </Link>
  )
}

export default Card
